var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCompanyCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88354 13.9605C7.41321 13.955 7.94127 13.9013 8.46111 13.8001C6.94256 8.7983 5.87798 6.03081 1.19746 3.07129C0.97339 3.41421 0.773168 3.772 0.598206 4.14214C4.77027 6.35839 6.99022 11.6675 6.87445 13.9605H6.88354Z",
    fill: "#0164C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95544 13.6859C9.55519 13.5033 10.1318 13.2523 10.6737 12.9382C8.58771 7.67202 5.05122 3.28922 2.03454 2.09412C1.85976 2.27259 1.69632 2.45558 1.55331 2.62954C5.30545 4.6628 7.78644 8.50339 8.95544 13.6995V13.6859Z",
    fill: "#0164C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1228 12.6423C11.6162 12.2817 12.0596 11.8578 12.4416 11.3816C9.16613 5.87151 7.155 3.32768 3.18496 1.16113C2.91783 1.3311 2.66436 1.52144 2.42682 1.73044C4.85106 3.00236 9.25919 6.81585 11.1228 12.6423V12.6423Z",
    fill: "#0164C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58027 13.8176C5.83506 13.8704 6.09276 13.9081 6.35204 13.9305C5.87536 9.63811 2.9472 6.44364 0.366332 4.76733C0.273127 5.03712 0.19731 5.31255 0.139343 5.59194C1.41956 6.68312 4.27736 9.5726 5.58708 13.8176H5.58027Z",
    fill: "#0164C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6987 11.0555C13.0626 10.5516 13.3573 10.0015 13.5749 9.4199C11.3618 5.16587 9.10549 2.98803 5.60531 0.168579C5.27812 0.232782 4.95636 0.321907 4.64288 0.435164C6.4588 1.72515 11.616 6.87155 12.6987 11.0533V11.0555Z",
    fill: "#0164C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7832 8.76514C13.9772 8.01251 14.0417 7.2326 13.9738 6.45853C12.512 4.39816 8.85751 0.824142 7.21638 0.0424679C6.88832 0.0334009 6.56001 0.0454759 6.23352 0.0786155C8.31955 1.39346 11.4974 4.7777 13.7832 8.76514Z",
    fill: "#0164C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.787 5.26341C13.6543 4.73988 13.4592 4.234 13.2059 3.75654C12.3705 2.14365 10.9277 0.92535 9.1927 0.367783C8.80499 0.247386 8.40898 0.155268 8.00781 0.0921631C9.96673 1.1472 12.5635 3.79495 13.787 5.2589V5.26341Z",
    fill: "#0164C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0446 13.6811C4.56604 13.5623 4.1073 13.3751 3.68266 13.1254C2.62262 10.4008 1.29246 8.41499 0.00316482 7.21311C-0.00661502 6.86248 0.00627736 6.51158 0.041756 6.1626C1.45817 7.74402 3.5442 9.75469 5.03552 13.6811H5.0446Z",
    fill: "#0164C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89861 11.7658C2.20721 12.0803 2.54125 12.3689 2.89736 12.6289C2.37982 11.3818 0.813592 9.2288 0.0917664 8.03369C0.161467 8.57688 0.302656 9.10858 0.511698 9.61511C0.842766 10.4106 1.31227 11.1418 1.89861 11.7749V11.7658Z",
    fill: "#0164C0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompanyCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/company-circle.c211dc12.svg";
export { ForwardRef as ReactComponent };